'use client'

// src/api/common/location.ts
var LOCATION_QUERY = `
address
city
location { lat lon }
subwayStation
subwayStationDistance
subwayStationLocation { lat lon }
busStation
busStationDistance
busStationLocation { lat lon }
minimumSuitableTemperature
maximumSuitableTemperature
`;

export {
  LOCATION_QUERY
};
//# sourceMappingURL=chunk-KJDK3CSR.mjs.map